import { render, staticRenderFns } from "./MentalDrawingContainer.vue?vue&type=template&id=718a1644&scoped=true&lang=pug&"
import script from "./MentalDrawingContainer.vue?vue&type=script&lang=js&"
export * from "./MentalDrawingContainer.vue?vue&type=script&lang=js&"
import style0 from "./MentalDrawingContainer.vue?vue&type=style&index=0&id=718a1644&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "718a1644",
  null
  
)

export default component.exports